/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { triggerViewFullProductAnalytics } from '../../utils/product-bundle-utils';

const { shape, string } = proptypes;

const ProductDetailsButton = ({ canonicalUrl, product, itemId }) => {

  if (!canonicalUrl) {
    return null;
  }
  return (
    <div className="[&_a]:hover:sui-no-underline" data-testid="bundle-product-details-button">
      <Button
        variant="secondary"
        href={canonicalUrl}
        target="_blank"
        id="PipButton"
        onClick={() => { triggerViewFullProductAnalytics(itemId, product); }}
      >
        View Full Product Details
      </Button>
    </div>
  );
};

ProductDetailsButton.propTypes = {
  canonicalUrl: string.isRequired,
  product: shape({ }).isRequired,
  itemId: string.isRequired
};

export { ProductDetailsButton };
